import type { FormControl } from '@angular/forms';
import { shareReplay, startWith } from 'rxjs';

export function selectControlValue<T>(ctrl: FormControl<T>, shareValue = true) {
  if (shareValue) return ctrl.valueChanges.pipe(startWith(ctrl.value), shareReplay(1));
  return ctrl.valueChanges.pipe(startWith(ctrl.value));
}
